// extracted by mini-css-extract-plugin
module.exports = {"card":"ItineraryPinCard_card__rEhOz","image":"ItineraryPinCard_image__byJM6","details":"ItineraryPinCard_details__1Pl_R","info":"ItineraryPinCard_info__tQyih"};